import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../components/common/blur-modal';
import { LoadingCircle } from '../../../components/common/loading';
import SimpleDate from '../../../components/common/date';
import { Card, CardBody } from '@dbk/ui-card';

import Button from '@dbk/ui-buttons';
class Article extends Component {
  constructor(props) {
    super(props);


    var currentLocation = window.location.pathname;

    var articleid = currentLocation.split('/')[4] || currentLocation.split('/')[3];
    this.props.getArticle( articleid );

    this.state = {
      modal: false,
      downloading: false,
      fileError: false,
    };
    this.openPDF = this.openPDF.bind(this);
    this.modalContent = this.modalContent.bind(this);

  }

  componentWillUnmount() {
    this.props.clearArticle();
  }

  componentDidUpdate() {
    const attachementFile = this.props.cioinsights.attachmentFile;
    if (attachementFile != null && attachementFile.pdfData != null) {

      setTimeout(() => {
        this.setState({
          downloading: false,
        });
      }, 500);
    }

  }

  renderPDFButton(data) {
    const { i18n: { messages }} = this.props;
    if (!data.attachments || data.attachments.length == 0) {
      return null;
    } else {
      let attachment = data.attachments[0].attachmentId;
      return (
        <div className="small-12 medium-push-2 medium-8 large-push-3 large-6 insight-button">


          <div>
            {this.state.downloading == false &&

            <Button fullWidth size="normal" onPress={() => this.openPDF(attachment)} testID="btn_clickPDF_article_test" id="btn_clickPDF_article_test">
            {messages['app.insight.clickPdf']}
            </Button>

            }
            {this.state.downloading == true &&
              <div className="pad-bottom-30">
                <LoadingCircle />
              </div>
            }
          </div>
        </div>
      );
    }

  }

  openPDF(attachment) {
    this.setState({ downloading: true });
    this.props.download(attachment);
    //const attachementFile = this.props.cioinsights.attachmentFile;
    //if (!attachementFile) {
    // this.setState({ downloading: false });
    //  return null;
    //}
    //else {
    //  this.setState({ modal: true });
    //}

    setTimeout(() => {
      this.setState({ modal: true });
    });

  }

  modalContent(attachementFile) {
    const { i18n: { messages }} = this.props;
    if (attachementFile == null || this.state.downloading == true) {
      return (
        <div className="pad-bottom-30">
          <LoadingCircle />
        </div>
      );
    }
    let url = "data:application/pdf;base64," + attachementFile.pdfData;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      if (!attachementFile.pdfData || attachementFile.pdfData === '') {
        return (
          <div>{messages['app.reports.unablePdf']}</div>
        );
      }

      var byteCharacters = atob(attachementFile.pdfData);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: 'application/pdf'
      });
      this.closeBlurModel();
      window.navigator.msSaveOrOpenBlob(blob, 'Article');
    }
    else {
      if (!attachementFile.pdfData || attachementFile.pdfData === '') {
        return (
          <div>{messages['app.reports.unablePdf']}</div>
        );
      }
      return (
        <div className="pad-10">
          <embed src={url} width="100%" style={{ 'minHeight': window.innerHeight }} />
        </div>
      )
    }
  }

  closeBlurModel() {
    this.setState({ modal: false });
  }


  render() {
    const article = this.props.cioinsights.articleContent;
    const isLoading = this.props.cioinsights.isLoading;
    const attachementFile = this.props.cioinsights.attachmentFile;
    if(isLoading) {
      return (<div className="center-content" style={{ 'minHeight': window.innerHeight - 100 }}><LoadingCircle /></div>);
    }
    if (!article) {
      return (null);
    }
    return (
      <div className="scene">
        <div className="container2">

         <Card active={false} >

        <CardBody>


          <div className="article-page">

            <div>
              { article.image.uri != '' &&
                  <img className="content-image" src={article.image.uri} />
                }


            </div>



              <div className="content-text">
                <div className="title">{article.title}</div>
                <div className="note"><SimpleDate value={article.date} /></div>

                <hr/>

                <div className="content-info">
                  {article.desc}
                </div>

              </div>

          </div>

          {this.renderPDFButton(article)}
          {this.props.cioinsights.showPdfModal && this.state.modal ? <BlurModal
            visible={this.state.modal}
            doneLabel={messages['app.calendar.doneBtn']}
            doneVisible={true}
            onDone={() => this.setState({ modal: false })}
          >
            {this.modalContent(attachementFile)}
          </BlurModal> : null}


          </CardBody>

          </Card>
        </div>
      </div>

    );
  }
}


export default createContainer({
  $queries: {
    getArticle: {
      $call: 'cioinsights.getArticle',
    },
    download: {
      $call: 'cioinsights.getAttachment',
    },
    clearfiles: {
      $call: 'cioinsights.clearAttachment',
    },

    clearArticle: {
      $call: 'cioinsights.clearArticle',
    },
    i18n: {
      messages: true,
    },
    cioinsights: {
      showPdfModal: true,
      articleContent: true,
      attachmentFile: true,
      isLoading: true,
    },
  }
})(Article);